import { IComponentOptions } from "angular";
import { ContractDetailComponentController } from "../../../../../../../Contract/shared/controllers/contractDetailComponentController";

export const vsComponentName = "gamingContractDetailComponent";

export const gamingContractDetailComponentOptions: IComponentOptions = {
  controller: ContractDetailComponentController,
  controllerAs: "gamingContractDetailController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contractType: "<",
    contract: "<",
  },
};
